import React, { Component } from "react";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import { wrapContent } from "../../globalHelpers/GlobalContentWrapper";
import styleWrap from "../../globalHelpers/GlobalStyleWrapper";
import { subscribe } from "../../globalHelpers/LanguageHelper";
import { isMobileOnly } from "react-device-detect";
import Cookies from "universal-cookie";
const cookies = new Cookies();
export default class ContentViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        const language = cookies.get("language");
        if (language) {
            this.setState({ language });
        }

        this.refresh(this.props);

        subscribe((results) => {
            if (results && typeof results === typeof "") {
                this.setState({ language: results });
            }
        });
    }

    componentWillReceiveProps(newProps) {
        if (
            newProps.overrideContent != this.props.overrideContent ||
            (newProps.widget &&
                newProps.widget.contentName != this.props.widget.contentName)
        ) {
            this.refresh(newProps);
        }
    }

    refresh(props) {
        Express.callPublic(
            "fetch-content",
            { contentName: props.overrideContent || props.widget.contentName },
            (results) => {
                this.setState({ content: results }, () => {
                    if (this.props.onLoad) {
                        this.props.onLoad();
                    }
                });
            }
        );
    }

    renderContent() {
        const { content, language } = this.state;
        let contentHtml =
            content.htmlMobile && isMobileOnly
                ? content.htmlMobile
                : content.html;
        let constants = {};

        try {
            if (language && content[language]) {
                if (isMobileOnly && content.htmlMobileEn && language == "en") {
                    contentHtml = content.htmlMobileEn;
                } else if (
                    isMobileOnly &&
                    content.htmlMobileEs &&
                    language == "es"
                ) {
                    contentHtml = content.htmlMobileEs;
                } else {
                    contentHtml = content[language];
                }
            }

            constants = { ...content.constants, ...this.props.constants };
        } catch (e) {
            console.log(e);
        }

        return (
            <div
                style={{
                    overflow: "hidden",
                    height: "100%",
                    ...this.props.style,
                }}
                dangerouslySetInnerHTML={{
                    __html: wrapContent(
                        contentHtml,
                        constants ? styleWrap(constants) : {}
                    ),
                }}
            />
        );
    }

    render() {
        if (!this.state.content) {
            return <div />;
        }

        return this.renderContent();
    }
}
